import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';

export default defineModule({
    id: 'withdrawal',
    requires: ['bank', 'kyc'],
    routes: [
        {
            path: '/withdrawal',
            name: 'withdrawal',
            meta: { requiresAuth: true },
            component: overridable('WithdrawalPage', () => import(/* webpackChunkName: "withdrawal" */ './views/WithdrawalPage.vue'))
        },
        {
            path: '/withdrawal-record',
            name: 'wtRecord',
            meta: { requiresAuth: true },
            component: overridable('WithdrawalRecordPage', () => import(/* webpackChunkName: "withdrawal" */ './views/WithdrawalRecordPage.vue'))
        }
    ],
    contributes: {
        'nav.menu': [
            {
                key: 'withdrawal',
                order: 20,
                label: 'nav.withdrawal',
                children: [
                    { to: '/withdrawal', label: 'nav.withdrawal' },
                    { to: '/withdrawal-record', label: 'nav.withdrawalRecord' }
                ]
            }
        ],
        'home.shortcuts': [
            { key: 'withdrawal', order: 20, icon: 'images/icons/shortcut-withdrawal.png', to: '/withdrawal' }
        ]
    }
});
